import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-page',
    list: 'flex flex-col gap-[8px]',

    productItem:
      'flex items-center gap-4 bg-white p-[20px] md:gap-6 md:px-[32px]',
    productImage: 'h-[100px] w-[100px] min-w-[100px]',
    productInfo:
      'flex w-full items-start justify-between gap-3 max-md:flex-col',
    productInfoLeft: 'flex flex-col gap-2',
    productInfoRight: 'flex flex-col gap-2 md:items-end',
    productName: 'md:text-s text-xs leading-[140%] font-semibold',
    productCount: 'text-xs leading-[140%] font-normal',
    productPrice: 'text-m leading-[140%] font-semibold'
  }
});
